import React from 'react';
import { PopoverProps as MantinePopoverProps } from '@mantine/core';
import Styled from './Popover.styles';

export interface PopoverProps
  extends React.PropsWithChildren,
    MantinePopoverProps {
  title?: string;
  body: React.ReactNode;
  clickable?: boolean;
}

export function Popover({
  title,
  body,
  children,
  position = 'bottom-start',
  clickable = true,
  ...rest
}: PopoverProps) {
  return (
    <Styled.Popover unstyled position={position} {...rest}>
      <Styled.Target>
        <Styled.TargetContainer $clickable={clickable}>
          {children}
        </Styled.TargetContainer>
      </Styled.Target>

      <Styled.Dropdown>
        {title && <Styled.Title>{title}</Styled.Title>}
        <Styled.Body>{body}</Styled.Body>
      </Styled.Dropdown>
    </Styled.Popover>
  );
}
